import React from "react";
import { Link } from "react-router-dom";
import { COMPANY } from "../constants/company";

export default function ThankYou() {
  return (
    <div className="glass-bg-light flex items-center justify-center py-10 px-4">
      <div className="relative z-10 max-w-2xl w-full">
        <div className="glass-card rounded-[2rem] p-8 sm:p-12 text-center animate-fade-up">
          {/* Animated check icon */}
          <div className="flex justify-center mb-6 animate-fade-up-delay-1">
            <div className="relative">
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-emerald-400 to-cyan-500 blur-2xl opacity-50"></div>
              <div className="relative h-20 w-20 flex items-center justify-center rounded-full bg-gradient-to-br from-emerald-400 to-cyan-500 shadow-2xl shadow-emerald-300 pulse-glow">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-12 w-12 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="3"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            </div>
          </div>

          {/* Title */}
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gradient-success animate-fade-up-delay-1">
            Thank You!
          </h1>
          <p className="mt-2 text-lg font-semibold text-slate-800 animate-fade-up-delay-2">
            Your agreement has been accepted.
          </p>

          {/* Subtext */}
          <p className="mt-4 text-slate-600 max-w-md mx-auto animate-fade-up-delay-2">
            A signed PDF copy has been sent to your email address. Please check
            your inbox for the document.
          </p>

          {/* Info Box */}
          <div className="mt-8 rounded-2xl bg-gradient-to-br from-indigo-50/80 to-purple-50/60 border border-indigo-200/60 p-6 backdrop-blur-sm text-left animate-fade-up-delay-3">
            <div className="flex items-start gap-3">
              <div className="shrink-0 h-10 w-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shadow-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </div>
              <div>
                <h2 className="font-bold text-base text-slate-900 mb-1">
                  What happens next?
                </h2>
                <p className="text-sm leading-relaxed text-slate-700">
                  Please check your email inbox for the PDF copy of your signed
                  agreement. The document will be available for download.
                </p>
              </div>
            </div>
          </div>

          {/* Divider */}
          <div className="my-8 flex items-center gap-4 animate-fade-up-delay-3">
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-slate-300 to-transparent"></div>
            <span className="text-xs uppercase tracking-widest text-slate-400 font-semibold">
              Support
            </span>
            <div className="flex-1 h-px bg-gradient-to-r from-transparent via-slate-300 to-transparent"></div>
          </div>

          {/* Support Text */}
          <p className="text-sm text-slate-600 animate-fade-up-delay-3">
            Questions or need assistance? Reach us at{" "}
            <a
              href={`mailto:${COMPANY.CONTACT.EMAIL}`}
              className="font-semibold text-indigo-700 hover:text-indigo-900 underline underline-offset-2"
            >
              {COMPANY.CONTACT.EMAIL}
            </a>
          </p>

          {/* Button */}
          <div className="mt-8 animate-fade-up-delay-3">
            <Link
              to="/"
              className="btn-gradient inline-flex"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                />
              </svg>
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
